"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var middleware = {
    onFetching: [],
    onFetched: [],
    onFetchingError: []
};
exports.default = middleware;
//# sourceMappingURL=middleware.js.map